import React, {useMemo} from 'react'
import {DatabaseMonth, DatabaseMonths, DatabaseMonthWithTemp} from '../../../services/PlantsService'
import './plantCalendar.less'
import {Table, Tag} from 'antd'
import {useIntl} from 'react-intl'
import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import * as Icons from '@fortawesome/free-solid-svg-icons'

export type PlantCalendarProps = {
  lifeCycle: string[]
  fruitingTime: DatabaseMonth[]
  plantingCloseTime: DatabaseMonth[]
  plantingOpenTime: DatabaseMonthWithTemp[]
  bloomingTime: DatabaseMonth[]
  pruningTime: DatabaseMonth[]
  mode: 'oneLine' | 'multiLine'
}

function useLowerCaseSetMemo(oldArray: string[] = []) {
  const newSet = useMemo(() => new Set(oldArray.map((x) => x.toLowerCase())), [oldArray])

  return newSet
}

export function PlantCalendar(props: PlantCalendarProps) {
  const fruitingTimeSet = useLowerCaseSetMemo(props.fruitingTime)

  const bloomingTimeSet = useLowerCaseSetMemo(props.bloomingTime)
  const pruningTimeSet = useLowerCaseSetMemo(props.pruningTime)
  const intl = useIntl()
  const plantingCloseTimeSet = useLowerCaseSetMemo(props.plantingCloseTime)
  const plantingOpenTimeSet = useLowerCaseSetMemo(props.plantingOpenTime)

  const monthsSplit =
    props.mode === 'oneLine'
      ? [DatabaseMonths]
      : [DatabaseMonths.slice(0, 6), DatabaseMonths.slice(6, DatabaseMonths.length)]

  return (
    <div>
      <div>
        {monthsSplit.map((months, index) => (
          <table key={index} className="plant-calendar">
            <thead>
              <tr>
                {months.map((n, index) => (
                  <th key={index}>{n}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {months.map((n, index) => (
                  <td key={index}>
                    {plantingCloseTimeSet.has(n) && (
                      <span>
                        <Tag icon={<Icon icon={Icons.faHouse} />} color="gray"></Tag>
                      </span>
                    )}
                    {plantingOpenTimeSet.has(n) && (
                      <span>
                        <Tag icon={<Icon icon={Icons.faSeedling} />} color="green"></Tag>
                      </span>
                    )}
                    {bloomingTimeSet.has(n) && (
                      <span>
                        <Tag icon={<Icon icon={Icons.faFan} />} color="orange"></Tag>
                      </span>
                    )}
                    {fruitingTimeSet.has(n) && (
                      <span>
                        <Tag icon={<Icon icon={Icons.faAppleWhole} />} color="red"></Tag>
                      </span>
                    )}
                    {pruningTimeSet.has(n) && (
                      <span>
                        <Tag icon={<Icon icon={Icons.faScissors} />} color="black"></Tag>
                      </span>
                    )}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        ))}
      </div>
      <div className="legend">
        <span>
          <Tag icon={<Icon icon={Icons.faHouse} />} color="gray"></Tag>-{' '}
          {intl.formatMessage({id: 'plantingSeedlingsInClosedGround'})},{' '}
        </span>
        <span>
          <Tag icon={<Icon icon={Icons.faSeedling} />} color="green"></Tag>-{' '}
          {intl.formatMessage({id: 'plantingSeedlingsInOpenedGround'})},{' '}
        </span>
        <span>
          <Tag icon={<Icon icon={Icons.faFan} />} color="orange"></Tag>-{' '}
          {intl.formatMessage({id: 'eventType-blooming'})},{' '}
        </span>
        <span>
          <Tag icon={<Icon icon={Icons.faAppleWhole} />} color="red"></Tag>-{' '}
          {intl.formatMessage({id: 'eventType-harvesting'})},{' '}
        </span>
        <span>
          <Tag icon={<Icon icon={Icons.faScissors} />} color="black"></Tag>-{' '}
          {intl.formatMessage({id: 'eventType-pruning'})}
        </span>
      </div>
    </div>
  )
}
